import api from './order-api';

const tools = {
    setRegionInSelect: async (select, country_id, zone_id = false) => {
        select.innerHTML = '<option>-Загрузка регионов-</option>';

        try {
            const json = await api.jsonData(`index.php?route=checkout/checkout/country&country_id=${country_id}`);
            let html = '<option value="">Выберите регион</option>';

            if (json.zone && json.zone.length > 0) {
                json.zone.forEach(zone => {
                    html += `<option value="${zone.zone_id}"${zone.zone_id == zone_id ? ' selected="selected"' : ''}>${zone.name}</option>`;
                });
            } else {
                html += '<option value="0" selected="selected">Регионы не указаны</option>';
            }

            select.innerHTML = html;
        } catch (error) {
            console.error(`Получение регионов: ОШИБКА ЗАПРОСА!\n${error.message}`);
        }
    },

    regionHandlerInPaymentAddress: () => {
        const paymentCountry = document.getElementById('input-payment-country');
        const paymentZone = document.getElementById('input-payment-zone');

        if (paymentCountry && paymentZone) {
            const countryId = paymentCountry.value;
            const zoneId = document.getElementById('payment_zone_id')?.dataset.zoneId;
            tools.setRegionInSelect(paymentZone, countryId, zoneId);

            paymentCountry.addEventListener('change', () => {
                tools.setRegionInSelect(paymentZone, paymentCountry.value);
            });
        }
    },

    getOffsetTop: (element) => {
        let offset = 0;
        while (element) {
            offset += element.offsetTop,
                element = element.offsetParent
        }
        return offset;
    },

    getScrollMargin: () => {
        const headerHeight = document.querySelector('.Header').offsetHeight;
        const gap = 24;
        return headerHeight + gap;
    },

    getErrorFields: () => {
        return {
            address_1: document.getElementById('message_for_input-payment-address-1'),
            city: document.getElementById('message_for_input-payment-city'),
            email: document.getElementById('message_for_input-payment-email'),
            firstname: document.getElementById('message_for_input-payment-firstname'),
            password: document.getElementById('message_for_input-payment-password'),
            confirm: document.getElementById('message_for_input-payment-confirm'),
            lastname: document.getElementById('message_for_input-payment-lastname'),
            telephone: document.getElementById('message_for_input-payment-telephone'),
            zone: document.getElementById('message_for_input-payment-zone'),
            agree: document.getElementById('message_for_guest-agree-checkbox'),
            warning: document.getElementById('message_for_agree-checkbox'),
        }
    },

    clearErrors: () => {
        const errorMessages = document.querySelectorAll('.error-message');
        if (errorMessages) {
            errorMessages.forEach((el) => {
                el.innerText = '';
            });
        }
    },

    save_data_for_edit_guest: () => {
        const nameEl = document.querySelector('#guest-fixed-name');
        const emailEl = document.querySelector('#guest-fixed-email');
        const phoneEl = document.querySelector('#guest-fixed-telephone');

        if (nameEl) {
            const firstname = nameEl.dataset.firstname || '';
            const lastname = nameEl.dataset.lastname || '';
            localStorage.setItem('order_firstname', firstname);
            localStorage.setItem('order_lastname', lastname);
        }

        if (emailEl) {
            const email = emailEl.dataset.value || '';
            localStorage.setItem('order_email', email);
        }

        if (phoneEl) {
            const phone = phoneEl.dataset.value || '';
            localStorage.setItem('order_phone', phone);
        }
    },

    fill_data_for_edit_guest: () => {
        const firstnameInput = document.querySelector('#input-payment-firstname');
        const lastnameInput = document.querySelector('#input-payment-lastname');
        const emailInput = document.querySelector('#input-payment-email');
        const phoneInput = document.querySelector('#input-payment-telephone');

        if (firstnameInput) {
            firstnameInput.value = localStorage.getItem('order_firstname') || '';
        }
        if (lastnameInput) {
            lastnameInput.value = localStorage.getItem('order_lastname') || '';
        }
        if (emailInput) {
            emailInput.value = localStorage.getItem('order_email') || '';
        }
        if (phoneInput) {
            phoneInput.value = localStorage.getItem('order_phone') || '';
        }
    },

    save_data_for_guest_to_register: () => {
        if (document.getElementById('guest-fixed-name')) {
            const nameEl = document.querySelector('#guest-fixed-name');
            const emailEl = document.querySelector('#guest-fixed-email');
            const phoneEl = document.querySelector('#guest-fixed-telephone');
            const addressEl = document.querySelector('#guest-fixed-address');

            if (nameEl) {
                const firstname = nameEl.dataset.firstname || '';
                const lastname = nameEl.dataset.lastname || '';
                localStorage.setItem('order_firstname', firstname);
                localStorage.setItem('order_lastname', lastname);
            }

            if (emailEl) {
                const email = emailEl.dataset.value || '';
                localStorage.setItem('order_email', email);
            }

            if (phoneEl) {
                const phone = phoneEl.dataset.value || '';
                localStorage.setItem('order_phone', phone);
            }

            if (addressEl) {
                const country = addressEl.dataset.country || '';
                const zone = addressEl.dataset.zone || '';
                const city = addressEl.dataset.city || '';
                const address1 = addressEl.dataset.address1 || '';
                localStorage.setItem('order_country', country);
                localStorage.setItem('order_zone', zone);
                localStorage.setItem('order_city', city);
                localStorage.setItem('order_address1', address1);
            }
        } else {
            const firstnameInput = document.querySelector('#input-payment-firstname');
            const lastnameInput = document.querySelector('#input-payment-lastname');
            const emailInput = document.querySelector('#input-payment-email');
            const phoneInput = document.querySelector('#input-payment-telephone');
            const cityInput = document.querySelector('#input-payment-city');
            const addressInput = document.querySelector('#input-payment-address-1');

            if (firstnameInput) {
                localStorage.setItem('order_firstname', firstnameInput.value);
            }

            if (lastnameInput) {
                localStorage.setItem('order_lastname', lastnameInput.value);
            }

            if (emailInput) {
                localStorage.setItem('order_email', emailInput.value);
            }

            if (phoneInput) {
                localStorage.setItem('order_phone', phoneInput.value);
            }

            if (cityInput) {
                localStorage.setItem('order_city', cityInput.value);
            }

            if (addressInput) {
                localStorage.setItem('order_address_1', addressInput.value);
            }
        }
    },

    fill_data_for_guest_to_register: () => {
        const firstnameInput = document.querySelector('#input-payment-firstname');
        const lastnameInput = document.querySelector('#input-payment-lastname');
        const emailInput = document.querySelector('#input-payment-email');
        const phoneInput = document.querySelector('#input-payment-telephone');
        const cityInput = document.querySelector('#input-payment-city');
        const addressInput = document.querySelector('#input-payment-address-1');

        if (firstnameInput) {
            firstnameInput.value = localStorage.getItem('order_firstname') || '';
        }
        if (lastnameInput) {
            lastnameInput.value = localStorage.getItem('order_lastname') || '';
        }
        if (emailInput) {
            emailInput.value = localStorage.getItem('order_email') || '';
        }
        if (phoneInput) {
            phoneInput.value = localStorage.getItem('order_phone') || '';
        }
        if (cityInput) {
            cityInput.value = localStorage.getItem('order_city') || '';
        }
        if (addressInput) {
            addressInput.value = localStorage.getItem('order_address_1') || '';
        }
    },
};

export default tools;
